import React, { useState, useEffect, useRef } from "react";
import Sidebar from "./Components/Sidebar";
import ChatMain from "./Components/ChatMain";
import GroupCreateModal from "./Components/GroupCreateModal";
import Login from "./Components/Login";
import { io } from "socket.io-client";
import "./Components/chat.css";
import axios from "axios";
import { API_URL, profilesEndpoint,authyEndpoint, chatEndpoint,SITE_URL } from "../../constants";
const dmKeyOf = (u) => String(u?.username || u);
const isRecruiter = (u) => String(u?.account_type || u?.accountType || u?.account?.account_type || "").toLowerCase() === "recruiter";

export default function Chat() {
  const [currentUser, setCurrentUser] = useState(null);
  const [selected, setSelected] = useState(null);
  const [mode, setMode] = useState("dm");
  const [inputText, setInputText] = useState("");
  const [groupModalOpen, setGroupModalOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [file, setFile] = useState(null);
  const [chatId, setChatId] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const messagesEndRef = useRef(null);

  const { socket, users, groups, setGroups, dmMessages, groupMessages, typingStatus, setDmMessages, setGroupMessages } = useChatSocket(currentUser);
  console.log(users)
  const scrollToBottom = () => {
    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  useEffect(() => {
    scrollToBottom();
  }, [dmMessages, groupMessages]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {

      fetch(authyEndpoint+"user/", {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("Invalid token");
          }
        })
        .then((userData) => {
          setCurrentUser({ ...userData, token });
        })
        .catch((error) => {
          localStorage.removeItem("token");
          setCurrentUser(null);
        });
    } else {
      setCurrentUser(null);
    }
  }, []);

  useEffect(() => {
    document.body.classList.toggle("dark-mode", darkMode);
  }, [darkMode]);

  useEffect(() => {
  }, [currentUser]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!currentUser?.username || !token) return;
    fetch(`${profilesEndpoint}me/`, {
      headers: { Authorization: `Token ${token}` },
    })
      .then(r => (r.ok ? r.json() : null))
      .then(profile => {
        if (!profile) return;
        setCurrentUser(prev => ({ 
          ...prev, 
          account_type: profile.account_type,
          organisation: profile.organisation
        }));
      })
      .catch(() => {});
  }, [currentUser?.username]);

  const handleLogin = () => {

    setCurrentUser(data);
  };
    console.log(currentUser);

  const handleLogout = () => {
    const token = localStorage.getItem("token");
    if (token) {

      fetch(authyEndpoint+"logout/", {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
        },
      }).finally(() => {
        localStorage.removeItem("token");
        setCurrentUser(null);
      });
    } else {
      setCurrentUser(null);
    }
  };

  const userId = currentUser?.pk;

  const handleDMSelect = async (user) => {
    setMode("dm");
    setSelected(user);
    setInputText("");
    const token = localStorage.getItem("token");
    
    const otherUserProfileId = user?.profile_pk || user?.pk;
    const peerUser = user?.username;
    
    if (!userId || !user) {
      console.error("Invalid user data:", { 
        currentUser: currentUser, 
        userId: userId, 
        user: user
      });
      return;
    }
    
    
    let newChatId = null;
    try {
      const res = await axios.get(`${chatEndpoint}dc_list`, {
        headers: { Authorization: `Token ${token}` },
      });
      const chats = res.data.results || res.data;
      const found = chats.find(
        c => (String(c.user) === String(userId) && String(c.user2) === String(otherUserProfileId)) || (String(c.user2) === String(userId) && String(c.user) === String(otherUserProfileId))
      );
      if (found) newChatId = found.id;
    } catch (error) {
      console.error("Error fetching chat list:", error);
    }
    
    if (!newChatId) {
      try {
        if (!otherUserProfileId) {
          console.error("No profile_pk for selected user");
          return;
        }
        const res = await axios.post(`${chatEndpoint}dc_create`, {
          user2: otherUserProfileId
        }, {
          headers: { Authorization: `Token ${token}` },
        });
        newChatId = res.data.id;
      } catch (error) {
        console.error("Failed to create chat:", error.response?.data || error.message);
      }
    }
    setChatId(newChatId);
    
    if (newChatId) {
      try {
        const res = await axios.get(`${chatEndpoint}${newChatId}/list`, {
          headers: { Authorization: `Token ${token}` },
        });
        const messages = res.data.results || res.data;
        setDmMessages((prev) => ({ 
          ...prev, 
          [peerUser]: messages.map(m => ({
          ...m,
            isOwn: String(m.from_user) === String(userId)
          })) 
        }));
      } catch (error) {
        console.error("Error loading messages:", error);
        setDmMessages((prev) => ({ ...prev, [peerUser]: [] }));
      }
    }
    
    socket?.emit("request_dm_history", peerUser, (hist) => {
      setDmMessages((prev) => ({
        ...prev,
        [peerUser]: (hist || []).map(m => ({
          ...m,
          isOwn: String(m.from_user) === String(userId)
        }))
      }));
    });
  };

  const handleGroupSelect = (groupName) => {
    if (!isRecruiter(currentUser)) {
      alert('Only recruiters can open groups.');
      return;
    }
    setMode("group");
    setSelected({ name: groupName });
    socket?.emit("join_group", groupName, (res) => {
      if (res.success) {
        setGroupMessages((prev) => ({
          ...prev,
          [groupName]: res.history || [],
        }));
        setTimeout(scrollToBottom, 0);
      } else {
        alert(res?.error || 'Failed to join group');
      }
    });
    setInputText("");
  };

  const handleSendMessage = async () => {
    if (!inputText.trim() && !file) return;
    const msg = {
      text: inputText,
      from_user: userId,
      name: currentUser.username,
      time: new Date().toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
      }),
    };
    if (mode === "dm") {
      msg.toId = selected.username;
      const token = localStorage.getItem("token");
      
      if (!userId) {
        console.error("CurrentUser not loaded:", currentUser);
        return;
      }
      
      const otherUserProfileId = selected?.profile_pk || selected?.pk;
      const chatKey = dmKeyOf(selected);
      let currentChatId = chatId;
      
      if (!currentChatId) {
        try {
          if (!otherUserProfileId) { 
            console.error("Missing profile_pk"); 
            return; 
          }
          const res = await axios.post(`${chatEndpoint}dc_create`, {
            user2: otherUserProfileId
          }, {
            headers: { Authorization: `Token ${token}` },
          });
          currentChatId = res.data.id;
          setChatId(currentChatId);
        } catch (error) {
          console.error("Failed to create chat:", error);
        }
      }
      
      if (currentChatId) {
        try {
          const res = await axios.post(`${chatEndpoint}${currentChatId}/create`, { text: inputText }, {
            headers: { Authorization: `Token ${token}` },
          });
          
          if (res.data.response === 'created') {
            const savedMsg = res.data.message;

          setDmMessages((prev) => ({
            ...prev,
              [dmKeyOf(selected)]: [...(prev[dmKeyOf(selected)] || []), { 
                ...msg, 
                isOwn: true, 
                ...savedMsg, 
                from_user: currentUser.pk || currentUser.id,
                name: currentUser.username,
                from: currentUser.username
              }],
            }));
            setTimeout(scrollToBottom, 0);
            socket?.emit("dm_message", {
              ...savedMsg,
              text: savedMsg?.text ?? msg.text,
              from_user: currentUser.pk || currentUser.id,
              from_username: currentUser.username,
              toId: selected.username,
              isOwn: false
            });
          } else {
            console.error("API returned unexpected response:", res.data);
            setDmMessages((prev) => ({
              ...prev,
              [dmKeyOf(selected)]: [...(prev[dmKeyOf(selected)] || []), { 
                ...msg, 
                isOwn: true, 
                from_user: currentUser.pk || currentUser.id,
                name: currentUser.username,
                from: currentUser.username
              }],
            }));
            setTimeout(scrollToBottom, 0);
          }
        } catch (error) {
          console.error("Failed to send message:", error.response?.data || error.message);
          setDmMessages((prev) => ({
            ...prev,
            [dmKeyOf(selected)]: [...(prev[dmKeyOf(selected)] || []), { 
              ...msg, 
              isOwn: true, 
              from_user: currentUser.pk || currentUser.id,
              name: currentUser.username,
              from: currentUser.username
            }],
          }));
          setTimeout(scrollToBottom, 0);
          socket?.emit("dm_message", { ...msg, toId: selected.username, isOwn: false });
        }
      }
    } else if (mode === "group") {
      msg.room = selected.name;
      msg.name = currentUser.username;
      msg.from = currentUser.username;
      setGroupMessages((prev) => ({
        ...prev,
        [selected.name]: [...(prev[selected.name] || []), { ...msg, isOwn: true }],
      }));
      setTimeout(scrollToBottom, 0);
      socket?.emit("group_message", { ...msg, isOwn: false });
    }
    setInputText("");
    setFile(null);
  };

  const handleSendFile = async (e) => {
    const fileObj = e.target.files[0];
    if (!fileObj || !selected) return;

    try {
      if (mode === "group") {
        const msg = {
          id: `tmp-${Date.now()}`,
          fileName: fileObj.name,
          fileData: URL.createObjectURL(fileObj),
          fileSize: fileObj.size,
          fileType: fileObj.type,
          text: `File: ${fileObj.name}`,
          time: new Date().toISOString(),
          from_user: currentUser?.pk,
          from_username: currentUser?.username,
          name: currentUser?.username,
          room: selected.name,
          isOwn: true,
        };
        setGroupMessages((prev) => ({
          ...prev,
          [selected.name]: [...(prev[selected.name] || []), msg],
        }));
        socket?.emit("group_message", { ...msg, isOwn: false });
        setTimeout(scrollToBottom, 0);
        e.target.value = '';
        return;
      }

      let currentChatId = chatId;
      const token = localStorage.getItem('token');
      const otherUserProfileId = selected?.profile_pk || selected?.pk;
      if (!currentChatId) {
        if (!otherUserProfileId) return;
        const createRes = await axios.post(`${chatEndpoint}dc_create`, { user2: otherUserProfileId }, {
          headers: { Authorization: `Token ${token}` }
        });
        currentChatId = createRes.data.id;
        setChatId(currentChatId);
      }

      const formData = new FormData();
      formData.append('content', fileObj);
      formData.append('text', `File: ${fileObj.name}`);
      formData.append('from_user', userId);

      const response = await axios.post(`${chatEndpoint}${currentChatId}/create`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Token ${localStorage.getItem('token')}`
        }
      });

      if (response.data?.response === 'created') {
        const saved = response.data.message;
        const fileContent = saved?.file_content?.[0];
        const serverFileURL = fileContent?.file_url || null;
        const msg = {
          id: saved.id,
          fileName: fileContent?.file_name || fileObj.name,
          fileData: serverFileURL || URL.createObjectURL(fileObj),
          fileSize: fileObj.size,
          fileType: fileObj.type,
          text: saved.text || `File: ${fileObj.name}`,
          time: saved.created || new Date().toISOString(),
          from_user: userId,
          from_username: currentUser.username,
          name: currentUser.username,
          isOwn: true
        };

        const dmKey = selected ? dmKeyOf(selected) : null;
        setDmMessages((prev) => ({
          ...prev,
          [dmKey]: [...(prev[dmKey] || []), msg],
        }));
        setTimeout(scrollToBottom, 0);

        const socketMsg = {
          ...msg,
          isOwn: false,
          fileData: serverFileURL || msg.fileData,
          toId: selected.username,
        };
        socket?.emit("dm_message", socketMsg);

        e.target.value = '';
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Failed to upload file. Please try again.");
    }
  };

  const handleTyping = () => {
    const key = mode === "dm" ? (selected ? dmKeyOf(selected) : null) : selected?.name;
    if (key) {
      socket?.emit("typing", { roomOrId: key, name: currentUser.username });
    }
  };

  const handleModalCreate = (name, membersUsernames = []) => {
    if (!name) return;
    if (!isRecruiter(currentUser)) {
      alert('Only recruiters can create groups.');
      return;
    }
    const recruitersSet = new Set(
      (users || [])
        .filter(u => isRecruiter(u))
        .map(u => String(u.username))
    );
    const allRecruiters = (membersUsernames || []).every(u => recruitersSet.has(String(u)));
    if (!allRecruiters) {
      alert('Groups can include recruiters only.');
      return;
    }
    const uniqueMembers = Array.from(new Set([...(membersUsernames || []), String(currentUser?.username)]));

    socket?.emit("create_group", name, (res) => {
      if (res?.success) {
        if (Array.isArray(groups)) {
          setGroups(prev => (prev.includes(name) ? prev : [...prev, name]));
        }
        socket?.emit("join_group", name, (joinRes) => {
          if (joinRes?.success) {
            setGroupMessages((prev) => ({
              ...prev,
              [name]: joinRes.history || [],
            }));
            setSelected({ name });
            setMode("group");
            setTimeout(scrollToBottom, 0);
          } else {
            alert(joinRes?.error || 'Failed to join group');
          }
        });
      } else {
        alert(res?.error || 'Failed to create group');
      }
    });
    setGroupModalOpen(false);
  };

  useEffect(() => {
    return () => {
      try {
        Object.values(dmMessages || {}).flat().forEach(m => {
          if (m && typeof m.fileData === 'string' && m.fileData.startsWith('blob:')) {
            URL.revokeObjectURL(m.fileData);
          }
        });
        Object.values(groupMessages || {}).flat().forEach(m => {
          if (m && typeof m.fileData === 'string' && m.fileData.startsWith('blob:')) {
            URL.revokeObjectURL(m.fileData);
          }
        });
      } catch (e) {}
    };
  }, [dmMessages, groupMessages]);

          const dmKey = selected ? dmKeyOf(selected) : null;
          const messages = mode === "dm"
            ? (dmMessages[dmKey] || [])
            : (groupMessages[selected?.name] || []);

  if (!currentUser) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="chat-responsive-container" style={{display: 'flex', height: '100vh', background: '#f5f5f5'}}>
      <div className="chat-responsive-main" style={{flex: 1, display: 'flex', background: '#fff'}}>
        <div className={`chat-responsive-sidebar ${!sidebarOpen ? 'sidebar-closed' : ''}`} style={{width: '320px', borderRight: '1px solid #e9ecef', display: 'flex', flexDirection: 'column'}}>
          <div style={{padding: '24px 20px 16px 20px', borderBottom: '1px solid #e9ecef'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px'}}>
              <h1 style={{fontSize: '20px', fontWeight: '600', color: '#2c3e50', margin: 0}}>Chat</h1>
              {isRecruiter(currentUser) && (
                <button 
                  onClick={() => setGroupModalOpen(true)}
                  style={{
                    background: '#19BFB7',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '6px 12px',
                    fontSize: '12px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}
                >
                  <span style={{fontSize: '14px'}}>+</span>
                  <span>New Group</span>
                </button>
              )}
            </div>
            <p style={{fontSize: '13px', color: '#7f8c8d', margin: 0}}>Internal communication hub.</p>
          </div>

          <div style={{flex: 1, padding: '16px 20px'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
              <h3 style={{fontSize: '15px', fontWeight: '600', color: '#2c3e50', margin: 0}}>Direct Messages</h3>
              <button
                onClick={() => {
                  if (!isRecruiter(currentUser)) {
                    alert('Only recruiters can create groups.');
                    return;
                  }
                  setGroupModalOpen(true);
                }}
                style={{
                  border: '1px solid #e9ecef', background: '#fff', borderRadius: '4px',
                  padding: '4px 8px', cursor: 'pointer', fontSize: '12px', color: '#6c757d',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '24px', height: '24px'
                }}
              >+
              </button>
            </div>

            {isRecruiter(currentUser) && groups.length > 0 && (
              <div style={{marginBottom: '20px'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px'}}>
                  <h4 style={{fontSize: '14px', fontWeight: '600', color: '#2c3e50', margin: 0}}>Groups</h4>
                </div>
                {groups.map((group, index) => (
                  <div 
                    key={index}
                    onClick={() => handleGroupSelect(group)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '8px 0',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f8f9fa',
                      background: selected?.name === group ? '#f8f9fa' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      background: '#e74c3c',
                      marginRight: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontWeight: 'bold',
                      fontSize: '12px'
                    }}>
                      G
                    </div>
                    <div style={{flex: 1}}>
                      <div style={{fontSize: '13px', fontWeight: '500', color: '#2c3e50'}}>
                        {group}
                      </div>
                      <div style={{fontSize: '11px', color: '#7f8c8d'}}>
                        Group Chat
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div>
              {users.filter(u => u.username !== currentUser?.username).map((user, index) => (
                <div 
                  key={dmKeyOf(user)} 
                  onClick={() => handleDMSelect(user)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '12px 0',
                    cursor: 'pointer',
                    borderBottom: '1px solid #f8f9fa',
                    background: (selected && dmKeyOf(selected) === dmKeyOf(user)) ? '#f8f9fa' : 'transparent'
                  }}
                >
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: user.avatar || '#19BFB7',
                    marginRight: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontWeight: 'bold',
                    backgroundImage: user.avatar ? `url(${user.avatar})` : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}>
                    {!user.avatar && user.name?.charAt(0)}
                  </div>
                  <div style={{flex: 1}}>
                    <div style={{fontSize: '14px', fontWeight: '600', color: '#2c3e50', marginBottom: '2px'}}>
                      {user.name || user.username || 'Unknown User'}
                    </div>
                    <div style={{fontSize: '12px', color: '#7f8c8d', display: 'flex', alignItems: 'center', gap: '8px'}}>
                      <span>{user.status === 'active' ? 'Online' : 'Offline'}</span>
                      {user.account_type && (
                        <span style={{
                          fontSize: '10px',
                          padding: '2px 6px',
                          borderRadius: '10px',
                          background: user.account_type === 'client' ? '#3498db' : 
                                     user.account_type === 'recruiter' ? '#e74c3c' : 
                                     user.account_type === 'candidate' ? '#27ae60' : '#95a5a6',
                          color: '#fff',
                          fontWeight: '500',
                          textTransform: 'capitalize'
                        }}>
                          {user.account_type}
                        </span>
                      )}
                    </div>
                  </div>
                  <div style={{fontSize: '11px', color: '#95a5a6'}}>
                    {user.lastMessageTime || ''}
                  </div>
                </div>
              ))}
              {users.length === 0 && (
                <div style={{textAlign: 'center', color: '#7f8c8d', padding: '20px'}}>
                  No users available
                </div>
              )}
            </div>
          </div>
        </div>

        <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
          <div style={{
            padding: '20px 24px',
            borderBottom: '1px solid #e9ecef',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <button 
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="mobile-menu-btn"
              style={{
                display: 'none',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                padding: '8px',
                borderRadius: '4px',
                color: '#666'
              }}
            >
              ☰
            </button>
            <div style={{display: 'flex', alignItems: 'center'}}>
              {selected ? (
                <>
                  {mode === 'group' ? (
                    <>
                      <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        background: '#e74c3c',
                        marginRight: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: '16px'
                      }}>
                        G
                      </div>
                      <div>
                        <div style={{fontSize: '16px', fontWeight: '600', color: '#2c3e50'}}>
                          {selected.name}
                        </div>
                        <div style={{fontSize: '12px', color: '#7f8c8d'}}>
                          Group Chat
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        background: selected.avatar || '#19BFB7',
                        marginRight: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontWeight: 'bold',
                        backgroundImage: selected.avatar ? `url(${selected.avatar})` : 'none',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                      }}>
                        {!selected.avatar && (selected.name?.charAt(0) || selected.username?.charAt(0))}
                      </div>
                      <div>
                        <div style={{fontSize: '16px', fontWeight: '600', color: '#2c3e50'}}>
                          {selected.name || selected.username || 'Unknown User'}
                        </div>
                        <div style={{fontSize: '12px', color: '#7f8c8d', display: 'flex', alignItems: 'center', gap: '8px'}}>
                          <span>{selected.status === 'active' ? 'Online' : 'Offline'}</span>
                          {selected.account_type && (
                            <span style={{
                              fontSize: '10px',
                              padding: '2px 6px',
                              borderRadius: '10px',
                              background: selected.account_type === 'client' ? '#3498db' : 
                                         selected.account_type === 'recruiter' ? '#e74c3c' : 
                                         selected.account_type === 'candidate' ? '#27ae60' : '#95a5a6',
                              color: '#fff',
                              fontWeight: '500',
                              textTransform: 'capitalize'
                            }}>
                              {selected.account_type}
                            </span>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <div style={{fontSize: '16px', fontWeight: '600', color: '#7f8c8d'}}>
                  Select a user to start chatting
                </div>
              )}
            </div>
            {currentUser && (
              <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                <span style={{fontSize: '12px', color: '#7f8c8d'}}>You:</span>
                {currentUser.account_type && (
                  <span style={{
                    fontSize: '10px',
                    padding: '2px 6px',
                    borderRadius: '10px',
                    background: currentUser.account_type === 'client' ? '#3498db' : 
                               currentUser.account_type === 'recruiter' ? '#e74c3c' : 
                               currentUser.account_type === 'candidate' ? '#27ae60' : '#95a5a6',
                    color: '#fff',
                    fontWeight: '500',
                    textTransform: 'capitalize'
                  }}>
                    {currentUser.account_type}
                  </span>
                )}
              </div>
            )}
          </div>

          <div className="chat-responsive-messages" style={{
            flex: 1, 
            padding: '20px 24px', 
            overflowY: 'auto',
            background: '#fff'
          }}>
            {typingStatus && selected && (
              <div style={{padding:'4px 24px', fontSize:12, color:'#7f8c8d'}}>
                {typingStatus.name} is typing...
              </div>
            )}
            {messages.length > 0 ? (
              messages.map((msg, i) => {
                const isOwn = !!msg.isOwn;
                
                return (
                <div key={i} style={{
                  display: 'flex',
                  justifyContent: isOwn ? 'flex-end' : 'flex-start',
                  marginBottom: '16px',
                  alignItems: 'flex-end'
                }}>
                  {!isOwn && (
                    <div style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      background: '#19BFB7',
                      marginRight: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontWeight: 'bold',
                      fontSize: '12px',
                      flexShrink: 0
                    }}>
                      {(msg.name || selected?.name || 'U').charAt(0).toUpperCase()}
                    </div>
                  )}
                  
                  <div style={{
                    maxWidth: '70%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: isOwn ? 'flex-end' : 'flex-start'
                  }}>
                    {!isOwn && (
                      <div style={{
                        fontSize: '12px',
                        color: '#7f8c8d',
                        marginBottom: '4px',
                        fontWeight: '500'
                      }}>
                        {msg.name || selected?.name || 'Unknown User'}
                      </div>
                    )}
                    
                    <div style={{
                      background: isOwn ? '#19BFB7' : '#f1f3f4',
                      color: isOwn ? '#fff' : '#23272f',
                      padding: '12px 16px',
                      borderRadius: '18px',
                      fontSize: '14px',
                      wordWrap: 'break-word',
                      position: 'relative'
                    }}>
                      {msg.text && <div style={{marginBottom: '4px'}}>{msg.text}</div>}
                      {msg.fileName && (
                        <div style={{marginBottom: '4px'}}>
                          {msg.fileData && (
                            <div>
                              <img 
                                src={msg.fileData} 
                                alt={msg.fileName} 
                                style={{
                                  maxWidth: 200, 
                                  maxHeight: 200,
                                  borderRadius: 8,
                                  objectFit: 'cover'
                                }} 
                                onLoad={() => { setTimeout(scrollToBottom, 0); }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'block';
                                }}
                              />
                              <a 
                                href={msg.fileData} 
                                download={msg.fileName}
                                style={{
                                  color: isOwn ? '#fff' : '#19BFB7', 
                                  textDecoration: 'underline',
                                  fontSize: '12px',
                                  display: 'none'
                                }}
                              >
                                📥 {msg.fileName}
                              </a>
                            </div>
                          )}
                          
                          {msg.fileName.match(/\.pdf$/i) && (
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '8px',
                              background: isOwn ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
                              borderRadius: '6px'
                            }}>
                              <span style={{fontSize: '20px'}}>📄</span>
                              <a 
                                href={msg.fileData} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                style={{
                                  color: isOwn ? '#fff' : '#19BFB7', 
                                  textDecoration: 'underline',
                                  fontWeight: '500'
                                }}
                              >
                                {msg.fileName}
                              </a>
                              <a 
                                href={msg.fileData} 
                                download={msg.fileName}
                                style={{
                                  color: isOwn ? '#fff' : '#19BFB7', 
                                  textDecoration: 'underline',
                                  fontSize: '12px'
                                }}
                              >
                                📥
                              </a>
                            </div>
                          )}
                          
                          {!msg.fileName.match(/\.(jpg|jpeg|png|gif|webp|pdf)$/i) && (
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '8px',
                              background: isOwn ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
                              borderRadius: '6px'
                            }}>
                              <span style={{fontSize: '20px'}}>📎</span>
                              <a 
                                href={msg.fileData} 
                                download={msg.fileName}
                                style={{
                                  color: isOwn ? '#fff' : '#19BFB7', 
                                  textDecoration: 'underline',
                                  fontWeight: '500'
                                }}
                              >
                                {msg.fileName}
                              </a>
                              {msg.fileSize && (
                                <span style={{
                                  fontSize: '11px',
                                  color: isOwn ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.5)'
                                }}>
                                  ({(msg.fileSize / 1024 / 1024).toFixed(1)} MB)
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    
                    <div style={{
                      fontSize: '11px',
                      color: '#7f8c8d',
                      marginTop: '4px',
                      textAlign: isOwn ? 'right' : 'left'
                    }}>
                      {msg.time ? (() => {
                        const time = new Date(msg.time);
                        if (isNaN(time.getTime())) {
                          return msg.time.split(':').slice(0, 2).join(':');
                        }
                        return time.toLocaleTimeString('en-US', { 
                          hour: '2-digit', 
                          minute: '2-digit',
                          hour12: true 
                        });
                      })() : ''}
                    </div>
                  </div>
                  
                  {msg.isOwn && (
                    <div style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      background: '#19BFB7',
                      marginLeft: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontWeight: 'bold',
                      fontSize: '12px',
                      flexShrink: 0
                    }}>
                      {(currentUser?.username || 'Y').charAt(0).toUpperCase()}
                    </div>
                  )}
                </div>
              );
              })
            ) : (
              <div style={{textAlign: 'center', color: '#7f8c8d', marginTop: '50px'}}>
                {selected ? 'No messages yet. Start the conversation!' : 'Select a user to view messages'}
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          <div className="chat-responsive-input" style={{
            padding: '20px 24px',
            borderTop: '1px solid #e9ecef',
            background: '#fff'
          }}>
            <div className="chat-responsive-input-container" style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
              <div style={{
                flex: 1,
                position: 'relative',
                display: 'flex',
                alignItems: 'center'
              }}>
              <input
                type="text"
                value={inputText}
                onChange={(e) => { setInputText(e.target.value); handleTyping(); }}
                onKeyDown={(e) => e.key === 'Enter' && handleSendMessage()}
                placeholder={selected ? "Type your message..." : "Select a user to start chatting"}
                style={{width: '100%',padding: '12px 16px',paddingRight: '50px',border: '1px solid #dee2e6',borderRadius: '20px',fontSize: '14px',
                  outline: 'none',
                  opacity: selected ? 1 : 0.7,
                  color: '#23272f',
                  backgroundColor: selected ? '#fff' : '#f8f9fa'
                }}
              />
              <input
                type="file"
                style={{display: 'none'}}
                id="file-upload-input"
                accept="*/*"
                onChange={handleSendFile}
                disabled={!selected}
              />
                          <label 
            htmlFor="file-upload-input" 
            style={{
              position: 'absolute',
              right: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
                cursor: selected ? 'pointer' : 'not-allowed', 
              opacity: selected ? 0.6 : 0.3,
              padding: '4px',
              borderRadius: '4px',
              transition: 'opacity 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} 
            title={selected ? 'Attach file' : 'Select user first'}
            onMouseEnter={(e) => selected && (e.target.style.opacity = '0.8')}
            onMouseLeave={(e) => selected && (e.target.style.opacity = '0.6')}
          >
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#666"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
          <path d="M21.44 11.05L12.25 20.24a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.19 9.19a2 2 0 01-2.83-2.83l8.19-8.19" />
        </svg>
          </label>
              </div>
              <button
                onClick={handleSendMessage}
                disabled={!selected || !inputText.trim()}
                style={{
                  background: selected && inputText.trim() ? 'linear-gradient(135deg, #19BFB7 0%, #15a8a0 100%)' : '#e9ecef',
                  color: selected && inputText.trim() ? '#fff' : '#6c757d',
                  border: 'none',
                  borderRadius: '12px',
                  width: '44px',
                  height: '44px',
                  cursor: (selected && inputText.trim()) ? 'pointer' : 'not-allowed',
                  fontSize: '16px',
                  opacity: (selected && inputText.trim()) ? 1 : 0.6,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease',
                  boxShadow: selected && inputText.trim() ? '0 2px 8px rgba(25, 191, 183, 0.3)' : 'none',
                  transform: (selected && inputText.trim()) ? 'scale(1)' : 'scale(0.95)'
                }}
                onMouseEnter={(e) => {
                  if (selected && inputText.trim()) {
                    e.target.style.transform = 'scale(1.05)';
                    e.target.style.boxShadow = '0 4px 12px rgba(25, 191, 183, 0.4)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selected && inputText.trim()) {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 2px 8px rgba(25, 191, 183, 0.3)';
                  }
                }}
              >
                <svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <line x1="22" y1="2" x2="11" y2="13" />
  <polygon points="22 2 15 22 11 13 2 9 22 2" />
</svg>

              </button>
            </div>
          </div>
        </div>
      </div>

      {sidebarOpen && (
        <div 
          className="mobile-overlay"
          onClick={() => setSidebarOpen(false)}
          style={{
            display: 'none',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 999
          }}
        />
      )}

      <GroupCreateModal open={groupModalOpen} onClose={() => setGroupModalOpen(false)} onCreate={handleModalCreate} />
    </div>
  );
}

function useChatSocket(currentUser) {
  const socket = useRef(null);

  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [dmMessages, setDmMessages] = useState({});
  const [groupMessages, setGroupMessages] = useState({});
  const [typingStatus, setTypingStatus] = useState(null);
  const profileMapRef = useRef({});

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!currentUser || !token) return;
    fetch(`${profilesEndpoint}profile_list`, {
      headers: { Authorization: `Token ${token}` },
    })
      .then(res => res.json())
      .then(data => {
        const list = data.results || data || [];
        const byId = {}, byUsername = {};
        list.forEach(p => {
          const rec = {
            account_type: p.account_type,
            picture: p.picture,
            first_name: p.first_name,
            last_name: p.last_name,
            username: p.username,
            pk: p.id,
            organisation: p.organisation
          };
          byId[String(p.id)] = rec;
          if (p.username) byUsername[String(p.username)] = rec;
        });
        profileMapRef.current = { byId, byUsername };
        if (users.length) {
          
          const { byId: _byId, byUsername: _byUser } = profileMapRef.current || {};
          setUsers(prev => prev.map(u => {
            console.log(u)
            const info = _byId?.[String(u.id)] || _byUser?.[String(u.username)] || _byUser?.[String(u.name)];
            if (!info) return u;
            const displayName = `${info.first_name || ''} ${info.last_name || ''}`.trim() || info.username;
            return {
              ...u,
              account_type: u.account_type || info.account_type,
              avatar: u.avatar || info.picture,
              name: u.name || displayName,
              username: u.username || info.username,
              profile_pk: info.pk,
              organisation: u.organisation || info.organisation,

            };
          }));
        }
      })
      .catch(() => {});
  }, [currentUser]);

  useEffect(() => {
    if (currentUser) {
socket.current = io("http://localhost:4000", {
  path: "/socket.io",
  transports: ["websocket", "polling"]
});
      socket.current.on("connect", () => {
        socket.current.emit("user_joined", currentUser);
      });

      socket.current.on("update_users", (users) => {
        const { byId, byUsername } = profileMapRef.current || {};
        const currentUserOrg = currentUser?.organisation;
        console.log(users)
         console.log("connectred")
        const enriched = (users || []).map(u => {
          const info =
            (byId && byId[String(u.id)]) ||
            (byUsername && byUsername[String(u.username)]) ||
            (byUsername && byUsername[String(u.name)]);
          if (!info) return u;
          const displayName = `${info.first_name || ''} ${info.last_name || ''}`.trim() || info.username;
          return {
            ...u,
            account_type: u.account_type || info.account_type,
            avatar: u.avatar || info.picture,
            name: u.name || displayName,
            username: u.username || info.username,
            profile_pk: info.pk,
            organisation: u.organisation || info.organisation
          };
        });
        
        const filtered = enriched.filter(u => {
          if (!currentUserOrg) return true;
          return String(u.organisation || '').toLowerCase() === String(currentUserOrg).toLowerCase();
        });
        
        setUsers(filtered);
      });
      
      socket.current.on("group_list", setGroups);

      socket.current.on("dm_message", (msg) => {
        const myUsername = String(currentUser?.username || "");
        const profiles = profileMapRef.current || {};
        const byId = profiles.byId || {};
        let senderUsername = msg.from_username || msg.from || msg.name || "";
        if (!senderUsername && msg.from_user) {
          const info = byId[String(msg.from_user)];
          if (info?.username) senderUsername = info.username;
        }
        senderUsername = String(senderUsername || "");
        if (!senderUsername) return;
        if (senderUsername === myUsername) return;
        const peerKey = dmKeyOf(senderUsername);
        const enriched = {
          ...msg,
          isOwn: false,
          name: msg.name || senderUsername,
          time: msg.time || new Date().toISOString(),
        };
        setDmMessages((prev) => ({
          ...prev,
          [peerKey]: [...(prev[peerKey] || []), enriched],
        }));
      });

      socket.current.on("group_message", (msg) => {
        const isOwn = msg.from_user === currentUser?.pk || 
                     msg.name === currentUser?.username ||
                     msg.from === currentUser?.username;
        setGroupMessages((prev) => ({
          ...prev,
          [msg.room]: [...(prev[msg.room] || []), { ...msg, isOwn }],
        }));
      });

      socket.current.on("typing", ({ roomOrId, name }) => {
        setTypingStatus({ name, roomOrId });
        setTimeout(() => setTypingStatus(null), 1500);
      });

      return () => socket.current?.disconnect();
    }
  }, [currentUser]);

  return {
    socket: socket.current,
    users,
    groups,
    dmMessages,
    groupMessages,
    typingStatus,
    setDmMessages,
    setGroupMessages,
    setGroups
  };
}